

define(['angular', 'squid/index', '../lib/util', 'components/xo-models/src/inventory/index', 'components/xo-models/src/shoppingcart/index'], function (angular, squid, util) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomultistepsignupapi', ['squid']).factory('$MultistepApiCalls', function ($UserInfoModel, $MultistepSignupModel, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $InventoryModel, $ShoppingCartModel, $CheckoutCartModel, $rootScope, $state, $config, $locale, $logger, $NationalIdModel, $location, $dispatch, $getRedirectUrl, $renderContent, $q, $FundingOptionsModel) {

        function userInfoTaxData(country, nationalId) {
            return {
                newDocId: {
                    type: nationalId.type,
                    subType: nationalId.subType,
                    issuerCountry: country,
                    issuer: country + '_' + nationalId.subType,
                    value: nationalId.value,
                    collectionPoint: 'UNKNOWN',
                    placeOfIssue: country
                }
            };
        }

        function processFieldMap(errorCategory) {
            var fieldMap = util.contingencyMap(errorCategory.errorCode || errorCategory.code);

            if (fieldMap) {
                if (!fieldMap.fields && (errorCategory.fields || errorCategory.details && errorCategory.details.fields)) {
                    // eslint-disable-line no-extra-parens
                    errorCategory.fields = errorCategory.fields || errorCategory.details && errorCategory.details.fields;

                    var fields = errorCategory.fields.map(function (value, index, array) {
                        if (angular.isString(value)) {
                            return {
                                field: value
                            };
                        }

                        return value;
                    });

                    fieldMap.fields = fields;
                }
            } else {
                $logger.info('signup_validation_error', {
                    message: errorCategory.errorCode || errorCategory.code + ' not mapped'
                });
            }

            return fieldMap;
        }

        function redirectTohermesCC(path, $location, token) {
            // eslint-disable-line no-shadow
            var url;
            var protocol;
            var host;
            var port;

            protocol = $location.protocol() + '://';

            if ($location.host()) {
                host = $location.host();
            }

            if ($location.port()) {
                port = ':' + $location.port();
            }

            url = protocol + host + port + config.urls.fallbackUrl.hermes + '?token=' + token + path; // eslint-disable-line no-undef,block-scoped-var

            window.location = url;
        }

        function setStickyInstrument(checkoutSession) {
            // make billing agreement FI sticky for sign up

            var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();

            if (stickyInstrument) {
                return checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: stickyInstrument.instrument_id
                    }
                });
            }
        }

        function showGenericError(code) {
            return function () {
                $state.go('checkout.genericError', { code: code });
            };
        }

        function markCartCheckedout(checkoutAppData) {
            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
            return shoppingCartModel.action('cartCheckedOut', {
                data: {
                    payee_email: checkoutAppData.get('merchant.merchant_email')
                },
                success: function success(result) {
                    $logger.info('cart checked out successfully');
                }
            });
        }

        function handlePaymentContingencies(checkoutCart, payee, code) {
            return function () {
                inventoryOperation(checkoutCart, payee, 'failed');
                return $state.go('checkout.genericError', { code: code });
            };
        }

        function makePayment(checkoutSession, checkoutCart, checkoutAppData, payee) {
            return checkoutSession.action('createPayment', {
                'data': {
                    payer_id: checkoutSession.payer && checkoutSession.payer.id,
                    intent: checkoutCart.payment_action
                },
                success: function success(result) {
                    $rootScope.paymentComplete = true;
                    if ($config.enableShoppingCartWPS && checkoutAppData.flags.is_shopping_cart_flow) {
                        markCartCheckedout(checkoutAppData);
                    }
                    return $state.go('checkout.done');
                },
                contingencies: {
                    TRANSACTION_REFUSED: handlePaymentContingencies(checkoutCart, payee, 'TRANSACTION_REFUSED'),
                    INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED(err, message) {
                        inventoryOperation(checkoutCart, payee, 'failed');
                        $logger.info('INSTRUMENT_DECLINED_contingency', {
                            name: err,
                            message: message
                        });
                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                    },
                    PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_DENIED'),
                    DUPLICATE_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_ALREADY_DONE'),
                    DEFAULT: handlePaymentContingencies(checkoutCart, payee, 'DEFAULT')
                },
                error: function error(err) {
                    $logger.info('createPayment Failed due to service error', err);
                    inventoryOperation(checkoutCart, payee, 'failed');
                    return $state.go('checkout.genericError', { code: 'DEFAULT' });
                }

            });
        }

        function authorizeSession(checkoutSession) {
            var multistepSignupModel = $MultistepSignupModel.instance();
            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
            var payee = $CheckoutPayeeModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);

            if (checkoutSession.resolve_3ds) {
                multistepSignupModel.resolve_3ds_data = {
                    cc_id: checkoutSession.get('resolve_3ds.ccId'),
                    flow_id: 'HERMES',
                    merchant_id: payee.get('merchant.id'),
                    merchant_country_code: checkoutAppData.get('merchant.merchant_country'),
                    transaction_amount_currency: checkoutCart.get('purchase.amounts.total.currency_code'),
                    transaction_amount_value: checkoutCart.get('purchase.amounts.total.amount')
                };

                multistepSignupModel.is3ds = true;
                $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
            } else {
                return $q.when(setStickyInstrument(checkoutSession))['catch'](function (err) {
                    $logger.info('setStickyFI Failed', err);
                })['finally'](function () {
                    return checkoutSession.action('authorize', {
                        success: function success() {
                            if (checkoutAppData.doec_on_approve()) {
                                return checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData);
                            } else {
                                $state.go('checkout.end');
                            }
                        }
                    });
                });
            }
        }

        function inventoryOperation(checkoutCart, payee, paymentStatus) {
            var cartHasInventory = checkoutCart.get('cartHasInventory');
            if (cartHasInventory) {
                var inventoryModel = $InventoryModel.instance($rootScope.token);
                var inventoryItems = inventoryModel.getInventoryItems();
                var purchaseItems = checkoutCart.get('purchaseUnits');
                var cartItems,
                    inventoryPatchInput = {};
                if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
                    cartItems = purchaseItems[0].item_list.items;
                }
                paymentStatus = paymentStatus ? paymentStatus : 'success';
                if (cartItems && inventoryItems) {
                    inventoryPatchInput = {
                        inventoryItems: inventoryItems,
                        cartItems: cartItems,
                        merchantId: payee.get('merchant.id', ''),
                        paymentStatus: paymentStatus
                    };
                } else {
                    return $q.when(); // don't need to call patchInventory if items not present
                }

                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse) {
                            if (patchResponse.showSoldoutPage) {
                                // show soldout page
                                return {
                                    soldoutpage: true,
                                    items: patchResponse.soldoutItems,
                                    soldOutUrl: patchResponse.soldoutUrl
                                };
                            } else if (patchResponse.patchCart) {
                                var purchase_unit = checkoutCart.get('purchaseUnits')[0];
                                purchase_unit.item_list.items = patchResponse.cartItems;
                                var patchCartPayload = {
                                    id: $rootScope.token,
                                    patchEntities: [{
                                        field: 'inventoryItems',
                                        value: purchase_unit.item_list.items
                                    }]
                                };

                                return checkoutCart.action('patchCartData', {
                                    data: patchCartPayload
                                });
                            }
                        } else {
                            return;
                        }
                    }
                });
            } else {
                return $q.when(); // not an inventory request proceed with existing flow
            }
        }

        function checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData) {
            return inventoryOperation(checkoutCart, payee).then(function (result) {
                if (result && result.soldoutpage) {
                    return $state.go('checkout.soldout', {
                        items: encodeURIComponent(result.items),
                        soldOutUrl: encodeURIComponent(result.soldOutUrl)
                    });
                }
                return makePayment(checkoutSession, checkoutCart, checkoutAppData, payee);
            });
        }

        function createSession() {

            var multistepSignupModel = $MultistepSignupModel.instance();
            var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);

            return checkoutSession.action('create', {
                data: {
                    fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                },
                success: function success() {
                    return $q.when().then(function () {
                        if (!multistepSignupModel.flags.shipToBilling) {
                            return multistepSignupModel.onboard.shipping_address.save({

                                data: multistepSignupModel.onboard.shipping_address.serialize(),

                                validation: function validation(message, err) {
                                    // TODO need to handle
                                }
                            });
                        }
                    }).then(function () {
                        if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && multistepSignupModel.onboard.card.ppconversion === 'VENDOR') {
                            return $FundingOptionsModel.instance($rootScope.token).action('updateConversion', {
                                data: {
                                    conversionType: 'VENDOR',
                                    planId: checkoutSession.plan.id
                                }
                            })['catch'](function (err) {
                                $logger.warn('ERROR_updateConversion to VENDOR failed', err);
                            });
                        }
                    }).then(function () {
                        return authorizeSession(checkoutSession);
                    });
                },
                contingencies: {
                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD(err, message) {
                        $logger.info('NEED_CREDIT_CARD_contingency', {
                            name: err,
                            message: message
                        });
                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                    }
                }
            });
        }

        var multiStepFunctions = {

            onboard: function onboard(isOASFlow) {

                var pageError = { // eslint-disable-line no-reserved-keys
                    multistepsignupaddcard: [],
                    multistepsignupaddshipping: [],
                    multistepsignupcreateaccount: [],
                    transient: true
                };

                var userInfo = $UserInfoModel.instance($rootScope.token);
                var multistepSignupModel = $MultistepSignupModel.instance();

                // addTaxId has to be blocked with OAS, as oas takes tax id in payload
                var addTaxId = !isOASFlow;

                multistepSignupModel.onboard.billing_address.country = $locale.country;
                multistepSignupModel.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);

                return multistepSignupModel.onboard.action(multistepSignupModel.flags.mode, {

                    data: multistepSignupModel.onboard.serialize(),

                    success: function success() {

                        if (addTaxId && util.componentsMap($locale.country).addTaxId) {

                            return userInfo.action('addTaxId', {

                                data: userInfoTaxData($locale.country.toUpperCase(), multistepSignupModel.onboard.nationalIdModel.nationalId),

                                success: createSession,

                                contingencies: {
                                    DEFAULT: function DEFAULT(err, message) {
                                        $logger.info('add_taxId_contingency', {
                                            name: err,
                                            message: message
                                        });
                                    }
                                },
                                validation: function validation(res) {
                                    redirectTohermesCC('#checkout/addTaxId', $location, $rootScope.token);
                                }
                            });
                        }

                        createSession();
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
                            var messages = [];
                            messages.push($locale.content.get('genericError.genericError'));

                            multistepSignupModel.pageError = pageError;
                            pageError.multistepsignupaddcard.errorMessage = {
                                msgs: messages,
                                type: 'error'
                            };

                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        },
                        ADD_KYC_FAILED: function ADD_KYC_FAILED() {
                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
                        },
                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
                            var messages = [];
                            messages.push($locale.content.get('creditcard.linkedCardToAddNewCard'));

                            multistepSignupModel.pageError = pageError;
                            pageError.multistepsignupaddcard.errorMessage = {
                                msgs: messages,
                                type: 'error'
                            };

                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        },
                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(message, result) {
                            // @TODO send to correct page in hermes
                            // $dispatch('hermes');
                            // auth model-> check if user logged in
                            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                        },
                        ISSUER_DECLINE: function ISSUER_DECLINE(message, result) {
                            // @TODO send to correct page in hermes
                            // $dispatch('hermes');
                            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                        },
                        VALIDATION_ERROR: function VALIDATION_ERROR(message, errors) {

                            var messages = [];
                            var compileVars = {
                                loginRedirectUrl: $getRedirectUrl('hermes', {
                                    hermesLoginRedirect: 'xoon'
                                })
                            };
                            // Iterate over the errorData to support multiple error support
                            Object.keys(errors).forEach(function (key, index, array) {

                                var errorCategory = errors[key];
                                // errorCategory sanity checks
                                if (!errorCategory || angular.isString(errorCategory) || key === 'transient' || key === 'payload') {
                                    return;
                                }

                                var fieldMap = processFieldMap(errorCategory);
                                var msg;
                                var compileMessageWith;

                                if (fieldMap) {

                                    if (fieldMap.pageError) {
                                        compileMessageWith = fieldMap.compileMessageWith;

                                        if (compileMessageWith) {
                                            // substitute the actual value
                                            // this is required as it is not good to have custom
                                            // code inside library - lib/utils.js
                                            $.each(compileMessageWith, function (objKey, val) {
                                                var actualValue = compileVars[val];
                                                if (actualValue) {
                                                    compileMessageWith[objKey] = actualValue;
                                                }
                                            });

                                            msg = $renderContent(fieldMap.pageError.contentKey, compileMessageWith);
                                        } else {
                                            msg = $locale.content.get(fieldMap.pageError.contentKey);
                                        }
                                        messages.push(msg);
                                    }

                                    pageError[fieldMap.path].push(fieldMap);

                                    if (messages.length > 0) {
                                        pageError[fieldMap.path].errorMessage = {
                                            msgs: messages,
                                            type: 'error'
                                        };
                                    }
                                }
                            });

                            multistepSignupModel.pageError = pageError;
                            throw pageError;
                        }
                    },
                    validation: function validation(res) {
                        if (res && (res.field === 'secondaryId' || res.field === 'passport')) {
                            // The validation error cannot be corrected at this point in onboarding
                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
                        } else {
                            $logger.info('signup_validation', {
                                message: res
                            });
                        }
                    }
                });
            },

            routeToHermesOn3DSDeclineForSignUp: function routeToHermesOn3DSDeclineForSignUp() {
                // dispatch to hermesnodeweb up on 3DS authenticate decline.
                $logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
                $dispatch('hermes', {
                    token: $rootScope.token,
                    redirectToHermesOn3DSDecline: 'xoon'
                });
            },

            clear3DSContingency: function clear3DSContingency() {
                var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
                return checkoutSession.action('clear3DSContingency', {
                    data: {
                        ccId: checkoutSession.resolve_3ds.ccId
                    },
                    success: function success() {
                        // don't call authorize if the contingency is not cleared
                        if (!checkoutSession.resolve_3ds) {
                            return authorizeSession(checkoutSession);
                        } else {
                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
                        }
                    },
                    contingencies: {
                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
                        DEFAULT: function handleContingency(name, contingency) {
                            $logger.info('clear3DSContingency_contingency', {
                                'int_error_description': contingency && contingency.message,
                                'contingency_name': name
                            });
                            // route to member review page upon patch xo throws contingency for signup
                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
                        }
                    }

                });
            }

        };

        return multiStepFunctions;
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/apiCalls/factory.js
// module id = ./components/xo-guest-components/src/multistep-signup/apiCalls/factory.js
// module chunks = 1